import { c as _c } from "react/compiler-runtime";
import { useMemo, useState } from "react";
import { CHECKOUT_STEPS } from "../types/checkout.type";
const useCheckoutState = () => {
  const $ = _c(33);
  const [currentStep, setCurrentStep] = useState(CHECKOUT_STEPS.ADDRESS);
  const [selectedShippingAddress, setSelectedShippingAddress] = useState(null);
  const [selectedBillingAddress, setSelectedBillingAddress] = useState(null);
  const [selectedShipping, setSelectedShipping] = useState(null);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [vatInvoice, setVatInvoice] = useState(false);
  const [comment, setComment] = useState("");
  const [selectedDeliveryPoint, setSelectedDeliveryPoint] = useState(null);
  const [isDeliveryPointRequired, setIsDeliveryPointRequired] = useState(false);
  let t0;
  let t1;
  if ($[0] !== currentStep) {
    t1 = step => currentStep >= step;
    $[0] = currentStep;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  t0 = t1;
  const isStepActive = t0;
  let t2;
  let t3;
  if ($[2] !== currentStep) {
    t3 = step_0 => currentStep > step_0;
    $[2] = currentStep;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  t2 = t3;
  const isStepCompleted = t2;
  let t4;
  let t5;
  if ($[4] !== selectedDeliveryPoint) {
    t5 = shippingId => {
      if (!shippingId) {
        return false;
      }
      const pointRequiredMethods = ["inpost_paczkomat", "gls_point"];
      const requiresPoint = pointRequiredMethods.includes(shippingId);
      setIsDeliveryPointRequired(requiresPoint);
      if (!requiresPoint && selectedDeliveryPoint) {
        setSelectedDeliveryPoint(null);
      }
      return requiresPoint;
    };
    $[4] = selectedDeliveryPoint;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  t4 = t5;
  const requiresDeliveryPoint = t4;
  let t6;
  let t7;
  if ($[6] !== selectedDeliveryPoint) {
    t7 = carrierName => {
      if (!carrierName) {
        return false;
      }
      const pointRequiredNames = ["InPost Paczkomat 24/7 dostawa D+1", "Odbi\xF3r w punkcie GLS"];
      const requiresPoint_0 = pointRequiredNames.includes(carrierName);
      setIsDeliveryPointRequired(requiresPoint_0);
      if (!requiresPoint_0 && selectedDeliveryPoint) {
        setSelectedDeliveryPoint(null);
      }
      return requiresPoint_0;
    };
    $[6] = selectedDeliveryPoint;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  t6 = t7;
  const requiresDeliveryPointByName = t6;
  let t8;
  const hasShippingAddress = selectedShippingAddress !== null;
  const hasBillingAddress = vatInvoice ? selectedBillingAddress !== null : true;
  const hasDeliveryPoint = isDeliveryPointRequired ? selectedDeliveryPoint !== null : true;
  t8 = hasShippingAddress && hasBillingAddress && selectedShipping && selectedPayment && hasDeliveryPoint;
  const isFormValid = t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = step_1 => {
      setCurrentStep(step_1);
      bb62: switch (step_1) {
        case CHECKOUT_STEPS.ADDRESS:
          {
            setSelectedShippingAddress(null);
            setSelectedBillingAddress(null);
            break bb62;
          }
        case CHECKOUT_STEPS.SHIPPING:
          {
            setSelectedShipping(null);
            setSelectedDeliveryPoint(null);
            setIsDeliveryPointRequired(false);
            break bb62;
          }
        case CHECKOUT_STEPS.PAYMENT:
          {
            setSelectedPayment(null);
          }
      }
    };
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const resetStep = t9;
  let t10;
  let t11;
  if ($[9] !== isDeliveryPointRequired || $[10] !== selectedBillingAddress || $[11] !== selectedDeliveryPoint || $[12] !== selectedPayment || $[13] !== selectedShipping || $[14] !== selectedShippingAddress || $[15] !== vatInvoice) {
    t11 = fromStep => {
      switch (fromStep) {
        case CHECKOUT_STEPS.ADDRESS:
          {
            return !!(selectedShippingAddress && (!vatInvoice || selectedBillingAddress));
          }
        case CHECKOUT_STEPS.SHIPPING:
          {
            return !!(selectedShipping && (!isDeliveryPointRequired || selectedDeliveryPoint));
          }
        case CHECKOUT_STEPS.PAYMENT:
          {
            return !!selectedPayment;
          }
        default:
          {
            return true;
          }
      }
    };
    $[9] = isDeliveryPointRequired;
    $[10] = selectedBillingAddress;
    $[11] = selectedDeliveryPoint;
    $[12] = selectedPayment;
    $[13] = selectedShipping;
    $[14] = selectedShippingAddress;
    $[15] = vatInvoice;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  t10 = t11;
  const canProceedToNextStep = t10;
  let t12;
  if ($[17] !== canProceedToNextStep || $[18] !== comment || $[19] !== currentStep || $[20] !== isDeliveryPointRequired || $[21] !== isFormValid || $[22] !== isStepActive || $[23] !== isStepCompleted || $[24] !== requiresDeliveryPoint || $[25] !== requiresDeliveryPointByName || $[26] !== selectedBillingAddress || $[27] !== selectedDeliveryPoint || $[28] !== selectedPayment || $[29] !== selectedShipping || $[30] !== selectedShippingAddress || $[31] !== vatInvoice) {
    t12 = {
      currentStep,
      setCurrentStep,
      selectedShippingAddress,
      setSelectedShippingAddress,
      selectedBillingAddress,
      setSelectedBillingAddress,
      selectedShipping,
      setSelectedShipping,
      selectedPayment,
      setSelectedPayment,
      vatInvoice,
      setVatInvoice,
      comment,
      setComment,
      selectedDeliveryPoint,
      setSelectedDeliveryPoint,
      isDeliveryPointRequired,
      requiresDeliveryPoint,
      requiresDeliveryPointByName,
      isStepActive,
      isStepCompleted,
      isFormValid,
      canProceedToNextStep,
      resetStep
    };
    $[17] = canProceedToNextStep;
    $[18] = comment;
    $[19] = currentStep;
    $[20] = isDeliveryPointRequired;
    $[21] = isFormValid;
    $[22] = isStepActive;
    $[23] = isStepCompleted;
    $[24] = requiresDeliveryPoint;
    $[25] = requiresDeliveryPointByName;
    $[26] = selectedBillingAddress;
    $[27] = selectedDeliveryPoint;
    $[28] = selectedPayment;
    $[29] = selectedShipping;
    $[30] = selectedShippingAddress;
    $[31] = vatInvoice;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
};
export default useCheckoutState;